import React from 'react';
import { IconTitle } from './styles';
export default function ModalTitle({
  children
}) {
  return <IconTitle data-testid="title-doc">{children}</IconTitle>;
}